import { render, staticRenderFns } from "./task_filter.vue?vue&type=template&id=6c044332&scoped=true"
import script from "./task_filter.vue?vue&type=script&lang=js"
export * from "./task_filter.vue?vue&type=script&lang=js"
import style0 from "./task_filter.vue?vue&type=style&index=0&id=6c044332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c044332",
  null
  
)

export default component.exports